var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6957 21.2167C15.6411 21.8276 16.7677 22.0938 17.8861 21.9706C19.0045 21.8474 20.0464 21.3422 20.8367 20.5401L21.5275 19.8636C21.8304 19.5533 22 19.1366 22 18.7027C22 18.2688 21.8304 17.8521 21.5275 17.5418L18.5952 14.6357C18.288 14.3333 17.8745 14.1639 17.4438 14.1639C17.013 14.1639 16.5995 14.3333 16.2923 14.6357V14.6357C15.9825 14.9391 15.5665 15.1089 15.1332 15.1089C14.6999 15.1089 14.2839 14.9391 13.9741 14.6357L9.36833 10.0229C9.21469 9.87123 9.09268 9.6905 9.0094 9.49121C8.92612 9.29191 8.88323 9.07802 8.88323 8.86198C8.88323 8.64593 8.92612 8.43204 9.0094 8.23275C9.09268 8.03345 9.21469 7.85272 9.36833 7.70108V7.70108C9.67025 7.3934 9.83942 6.97926 9.83942 6.54787C9.83942 6.11648 9.67025 5.70234 9.36833 5.39466L6.45135 2.4732C6.14155 2.16985 5.7255 2 5.29224 2C4.85898 2 4.44293 2.16985 4.13312 2.4732L3.45761 3.16512C2.65674 3.9566 2.15239 5.00011 2.02937 6.12021C1.90635 7.24031 2.17216 8.36867 2.7821 9.31557C5.96014 14.0064 10.0038 18.0459 14.6957 21.2167V21.2167Z",
    stroke: "#736A85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.205787a6.svg";
export { ForwardRef as ReactComponent };